<template>
    <div 
        class="conversations--message-container overflow-hidden" 
        :class="{
            'card' : !$breakpoint.smAndDown,
        }"
    >
        <div class="overlay bottom"></div>
        <div class="text-center py-3 border-bottom">
            {{counterpartName}} - <button type="button" class="btn btn-link" @click="goToMyBuyersOrSellers()">{{accountName}}</button>
        </div>
        <div 
            class="conversations--message-content pb-4" id="chat-room-container"
        >
            <div
                class="conversations--message my-2"
                :class="[$breakpoint.smAndDown ? 'mx-4' : 'mr-3 ml-4']"
                v-for="(message, key) in messagesList" :key="key">
                <!-- Day separator -->
                <div class="conversations--day-tripper" v-if="key == 0 || key !== 0 &&
                    moment(message.sent).format('DD-MM-YYYY') !== moment(messagesList[key - 1].sent).format('DD-MM-YYYY')">
                    <div class="text">
                        <span class="bg-white px-3" v-if="moment(message.sent).isSame(moment(), 'day')">Today</span>
                        <span class="bg-white px-3" v-else>{{message.sent | timestampformat}}</span>
                    </div>
                </div>
                
                <!-- Message bubble -->
                <div class="conversations-bubble" :class="message.user_id == userLoggedIn.userId ? 'user text-right' : 'recipient text-left'">
                    <!-- Message -->
                    {{message.message}}
                    <!-- Timestamp -->
                    <small class="timestamp">{{message.sent | timeformat}}</small>
                </div>
            </div>
        </div>

        <div class="conversations--message-input mx-4">
            <form v-on:submit.prevent="onSubmit">
                <textarea class="message-input pl-0" rows="2" type="text" placeholder="Write a message here..." v-model="inputData" 
                    @keydown.enter.exact.prevent="onSubmit" :disabled="userLoggedIn.category == 'seller' && getConversationId == ''">
                </textarea>
                <button class="btn btn-actionable btn-send-message" type="submit" 
                    :disabled="(userLoggedIn.category == 'seller' && getConversationId == '') || inputData.trim().length < 1">
                    <i class="fas fa-arrow-right"></i>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import breakpoint from '@/mixins/index';

export default {
    mixins: [breakpoint],
    data:function(){
        return {
            inputData: '',
            accountName: '',
            counterpartName: ''
        }
    },
    created(){
        this.getAccountName();
    },
    updated(){
        this.getAccountName();
    },
    methods:{
        ...mapActions('conversation',['sendMessage', 'deselectConversation', 'getGenericConversationsList']),
        ...mapActions('notifications', ['sendNotification', 'updateNotification']),
        ...mapGetters('conversation',['getParticipants']),
        ...mapGetters('login', ['getUserId', 'getAccountType']),
        onSubmit: function (){
            /* Prevent sending an empty message or only whitespace */
            if (this.inputData.trim().length < 1){
                return
            }
            
            let payload = {
                conversationId: this.getConversationId,
                message: this.inputData,
            }

            this.sendMessage(payload).then(() => {
                /* Create payload for Notification */
                let notificationPayload = {
                    group_id: this.getConversationId,
                    content: this.inputData,
                    participants: this.participants,
                    type_id: 'MESSAGE',
                }
                this.sendNotification(notificationPayload);
                this.inputData = ''
                
                this.getGenericConversationsList()

                /* Remove red dot notifications for this conversation */
                let currentRelevantNotification = this.notificationList.find(notification => {
                    if (notification.type_id === 'MESSAGE' && payload.conversationId === notification.group_id && notification.viewed === null){
                        return notification
                    }
                })

                if(currentRelevantNotification){
                    this.updateNotification(currentRelevantNotification.group_id);
                }
            })
        },
        moment: function (date) {
            const moment = require('moment')
            return moment(date);
        },
        getAccountName(){
            const counterpartUser = this.getParticipants().find(counterpartUserId => counterpartUserId.id !== this.getUserId())
            if (counterpartUser) {
                this.counterpartName = `${counterpartUser.firstName} ${counterpartUser.lastName}`
                this.getCounterpartAccountName(counterpartUser.id)
            }
            
        },
        getCounterpartAccountName: async function(counterpartUserId){
            const response = await this.axios.get('/api/getUserDetails', {params: {
                userId: counterpartUserId
            }})

            if (response.data.success){
                this.accountName = response.data.user.account.name
            }
        },
        goToMyBuyersOrSellers(){
            if(this.getAccountType() === 'seller'){
                this.$router.push('/MyCustomers');
                return;
            }
            this.$router.push('/MySuppliers')
        },
    },
    computed:{
        ...mapState('conversation', ['participants']),
        ...mapState('login', ['userLoggedIn']),
        ...mapState('notifications', ['notificationList']),
        ...mapGetters('conversation', ['getConversationId', 'messagesList']),
        scrollToLastMessage: function(){
            if (this.getConversationId && this.messagesList.length){
                setTimeout(() => {
                    const chatRoomContainer = document.getElementById('chat-room-container');
                    chatRoomContainer.scrollTop = chatRoomContainer.scrollHeight;
                }, 100)
            }
        },
    },
    watch: {
        scrollToLastMessage(){},
    },
    beforeDestroy(){
        this.deselectConversation()
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/_conversations.scss";
@import "@/assets/scss/components/_conversations-bubble.scss";
</style>
